import { Point } from '../types';
import { PIXELS_PER_METER } from '../constants/floorPlanConstants';
import { FloorPlanElement } from '../types';

export type LightType = 'low-energy' | 'non-low-energy';

export type LightElement = {
  id: string;
  type: 'light';
  lightType: LightType;
  position: Point;
  floor: number;
};

export function createLightElement(point: Point, lightType: LightType, floor: number): LightElement {
  return {
    id: `light-preview-${Date.now()}`,
    type: 'light',
    lightType,
    position: point,
    floor,
  };
}

function drawX(ctx: CanvasRenderingContext2D, center: Point, size: number) {
    ctx.beginPath();
    ctx.moveTo(center.x - size / 2, center.y - size / 2);
    ctx.lineTo(center.x + size / 2, center.y + size / 2);
    ctx.moveTo(center.x + size / 2, center.y - size / 2);
    ctx.lineTo(center.x - size / 2, center.y + size / 2);
    ctx.stroke();
}

function drawO(ctx: CanvasRenderingContext2D, center: Point, radius: number) {
    ctx.beginPath();
    ctx.arc(center.x, center.y, radius, 0, 2 * Math.PI);
    ctx.stroke();
}

export function drawLights(
  ctx: CanvasRenderingContext2D,
  elements: FloorPlanElement[],
  currentFloor: number,
  scale: number,
  viewOffset: Point,
  isEstate: boolean = false
) {
  const lightElements = elements.filter(
    (e) => e.type === 'light' && e.floor === currentFloor
  ) as LightElement[];

  ctx.save();
  ctx.lineWidth = 2 / scale;

  lightElements.forEach(light => {
    const size = 0.15 * PIXELS_PER_METER; // 15cm diameter
    // 🏢 ESTATE MODE: Use black for all lights
    const color = isEstate ? '#000000' : (light.lightType === 'low-energy' ? '#22c55e' : '#f97316');
    ctx.strokeStyle = color;
    if (light.lightType === 'low-energy') {
      drawX(ctx, light.position, size);
    } else {
      drawO(ctx, light.position, size / 2);
    }
  });

  ctx.restore();
}

export function drawLightPreview(
    ctx: CanvasRenderingContext2D,
    preview: LightElement | null,
    scale: number,
    viewOffset: Point
) {
    if (!preview) return;

    ctx.save();
    // Canvas context is already transformed, no need to apply transformation again
    ctx.lineWidth = 1.5 / scale;
    
    const size = 0.15 * PIXELS_PER_METER;
    ctx.globalAlpha = 0.6;

    if (preview.lightType === 'low-energy') {
        ctx.strokeStyle = '#22c55e';
        drawX(ctx, preview.position, size);
    } else {
        ctx.strokeStyle = '#f97316';
        drawO(ctx, preview.position, size / 2);
    }

    ctx.restore();
} 